import { render, staticRenderFns } from "./MasterHolidayNew.vue?vue&type=template&id=65442a4a&scoped=true&lang=pug&"
import script from "./scripts/MasterHolidayNew.js?vue&type=script&lang=js&"
export * from "./scripts/MasterHolidayNew.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65442a4a",
  null
  
)

export default component.exports